import { render, staticRenderFns } from "./VisitorsBarChart.vue?vue&type=template&id=16f13702&"
import script from "./VisitorsBarChart.vue?vue&type=script&lang=js&"
export * from "./VisitorsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports